import _ from 'lodash'
import store from '@/store'
import $glHttp from '@/services/$glHttp.js'

export default {

  // fn: login
  login (request) {
    return $glHttp.post('login', request)
      // on success => get user
      .then(() => this.getUser())
  },

  // fn: log out
  logout () {
    // store: commit logout
    store.commit('logout')

    // logout
    return $glHttp.post('logout')
  },

  // fn: returns true if a user is logged in
  isLoggedIn () {
    return store.getters.isLoggedIn
  },

  // fn: get config then commit cofig to store
  getConfig () {
    return $glHttp.post('config')
      .then(r => {
        // reserve bar
        // r.results = {
        //   agency: {
        //     modeOrganization: true,
        //     periscopeApiKey: 'abc',
        //     bgColor: '#f6f5f3',
        //     brandBtnBgColor: '#b59049',
        //     brandBtnTextColor: '#fff',
        //     linkColor: '#b59049',
        //     fontFamily: '"ProximaNovaAlt","Helvetica Neue",Helvetica,Arial,sans-serif',
        //     favicon: 'https://d3qe52j735cx7j.cloudfront.net/assets/images/favicon-32x32.png',
        //     loginLogo: 'https://d3qe52j735cx7j.cloudfront.net/assets/images/reservebar-intel-logo.svg',
        //     headerLogo: 'https://d3qe52j735cx7j.cloudfront.net/assets/images/reservebar-intel-logo.svg'
        //   },
        //   gid_7: {
        //     domain: 'shredlights.com'
        //   },
        //   gid_8: {
        //     domain: 'google.com'
        //   }
        // }

        // commerce accelerate
        // r.results = {
        //   agency: {
        //     modeOrganization: true,
        //     periscopeApiKey: 'abc',
        //     bgColor: '#FAFBFC',
        //     brandBtnBgColor: '#252b2d',
        //     brandBtnTextColor: '#fff',
        //     linkColor: '#252b2d',
        //     headerBgColor: '#252b2d',
        //     headerTextColor: '#FFFFFF',
        //     headerBorderColor: '#000',
        //     fontFamily: '"ProximaNovaAlt","Helvetica Neue",Helvetica,Arial,sans-serif',
        //     favicon: 'https://d3krb4bp54v1jy.cloudfront.net/assets/img/favicon-32x32.png',
        //     loginLogo: 'https://d3krb4bp54v1jy.cloudfront.net/assets/img/accelerate-logo-dark.png',
        //     headerLogo: 'https://d3krb4bp54v1jy.cloudfront.net/assets/img/accelerate-logo-light.png'
        //   },
        //   gid_1: {
        //     domain: 'verydaycalifornia.com'
        //   },
        //   gid_2: {
        //     domain: 'shredlights.com'
        //   }
        // }

        // material bank
        // r.results = {
        //   agency: {
        //     modeOrganization: true,
        //     periscopeApiKey: 'abc',
        //     bgColor: '#fbfaff',
        //     brandBtnBgColor: '#4C4E56',
        //     brandBtnTextColor: '#fff',
        //     linkColor: '#4C4E56',
        //     headerBgColor: '#4C4E56',
        //     headerTextColor: '#FFFFFF',
        //     headerBorderColor: '#000',
        //     fontFamily: '"Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
        //     favicon: 'https://d2pf9s47mqgf0y.cloudfront.net/assets/images/favicon-32x32.png',
        //     loginLogo: 'https://d2pf9s47mqgf0y.cloudfront.net/assets/images/material-bank-logo.png',
        //     headerLogo: 'https://d2pf9s47mqgf0y.cloudfront.net/assets/images/material-bank-logo-light.png'
        //   },
        //   gid_1: {
        //     domain: 'example.com'
        //   }
        // }

        return this.commitConfig(r.results)
      })
  },

  // fn: upsert config
  upsertConfig (config) {
    return $glHttp.post('config/upsert', config)
      // on success => update store config
      .then(() => this.getConfig())
  },

  // fn: commit to store config
  commitConfig (config) {
    // if config is undefined -> set config to store config
    if (!config) {
      config = store.getters.config
    }

    // if config -> continue
    if (_.isObject(config)) {
      // define config agency defaults
      const CONFIG_AGENCY_DEFAULTS = {
        bgColor: '#FAFBFC',
        brandBtnBgColor: '#2196F3',
        brandBtnTextColor: '#fff',
        linkColor: '#2196F3',
        headerBgColor: '#FAFBFC',
        headerTextColor: '#5A6772',
        headerBorderColor: '#D8D9DC',
        fontFamily: '"ProximaNovaAlt","Helvetica Neue", Helvetica, Roboto, Arial, sans-serif'
      }

      // merge current agency config w/ agency config defaults
      config.agency = { ...CONFIG_AGENCY_DEFAULTS, ...config.agency }

      // if group in store
      if (_.isObject(store.getters.group)) {
        // get group config
        let groupConfig = config['gid_' + store.getters.group.id]

        // if group config -> merge group config w/ agency config
        if (groupConfig) {
          config.agency = { ...config.agency, ...groupConfig }
        }
      }

      // store: commit config
      store.commit('config', config)
    }

    return config
  },

  // fn: delete config properties
  deleteConfig (keys) {
    // build pretty keys
    const PRETTY_KEYS = _.map(keys, (key) => {
      if (key.agency) return key.prop
      if (key.groupId) return 'gid_' + key
    })

    // delete config
    return $glHttp.post('config/delete', { keys: PRETTY_KEYS })
      // on success => update store config
      .then(() => this.getConfig())
  },

  // fn: get user then commit user to store
  getUser () {
    return $glHttp.post('user/me').then(r => {
      // store: commit user
      store.commit('user', r.results)

      return r.results
    })
  },

  // fn: get user groups then commit groups to store
  getUserGroups () {
    return $glHttp.post('user/groups', '', { params: { active: '1' } }).then(r => {
      if (_.isObject(r) && _.isArray(r.results)) {
        // store: commit user groups
        store.commit('userGroups', _.sortBy(r.results, 'name'))

        return r.results
      }
    })
  },

  // fn: get all groups then commit groups to store
  getAllGroups () {
    return $glHttp.post('getallgroups').then(r => {
      if (_.isObject(r)) {
        return r.results
      }
    })
  },

  // fn: get all users
  getUsers () {
    return $glHttp.post('user/all').then(r => {
      // if possible
      if (_.isObject(r)) {
        // add name property to response
        return _.map(r.results, user => {
          return {
            ...user,
            name: user.firstName + ' ' + user.lastName
          }
        })
      } else {
        return r
      }
    })
  },

  // fn: get active dashboards then commit dashboards to store
  getActiveDashboards () {
    return $glHttp.post('user/dashboards', '', { params: { active: 1 } }).then(r => {
      if (_.isObject(r) && _.isArray(r.results)) {
        // sort dashboards by name
        let dashboards = _.sortBy(r.results, 'name')

        // store: commit dashboards
        store.commit('activeDashboards', dashboards)

        return dashboards
      }
    })
  },

  // fn: get all dashboards
  getAllDashboards () {
    return $glHttp.post('user/alldashboards')
      .then(r => {
        if (_.get(r, 'results.length')) {
          // sort dashboards by name
          let dashboards = _.sortBy(r.results, 'name')

          // store: commit dashboards
          store.commit('allDashboards', dashboards)

          return dashboards
        }
      })
  },

  // fn: get dashboard by id & type
  getDashboard ({ id, type }, params) {
    return $glHttp.post(`user/dashboard/${type}/${id}`, params)
  },

  // fn: commit group by id
  commitGroup (groupId) {
    // get the full group object or null if not found
    let group = _.find(store.getters.groups.user, { id: groupId }) || null

    // store: commit group
    store.commit('group', group)

    // store: clear dashboards
    store.commit('activeDashboards', [])

    // store: clear current dashboard
    store.commit('dashboard', {
      meta: null,
      is404: false,
      isLoading: true
    })

    // commit config b/c some config is based off group
    this.commitConfig()

    // get fresh dashboards
    return this.getActiveDashboards()
      // on success => commit first dashboard so we have a default
      .then(() => this.commitFirstDashboard())
  },

  // fn: commit dashboard
  commitDashboard (dashboard, params) {
    // store: clear current dashboard
    store.commit('dashboard', {
      meta: dashboard,
      is404: false,
      isLoading: true
    })

    // get full dashboard
    return this.getDashboard(dashboard, params)
      .then(r => {
        // store: commit dashboard
        store.commit('dashboard', {
          meta: r.results,
          is404: false,
          isLoading: false
        })
      })
      .catch(e => {
        // store: commit dashboard
        store.commit('dashboard', {
          meta: null,
          is404: true,
          isLoading: false
        })

        // notify error
        console.log('er: commitDashboard(): ', e)
      })
  },

  // fn: commit first group to store
  commitFirstGroup () {
    // get firt group
    let group = _.find(store.getters.groups.user, { isActive: true })

    // if group -> commit group
    // else -> 404 store dashboard
    if (group) {
      return this.commitGroup(group.id)
    } else {
      // store: 404 store dashboard
      store.commit('dashboard', {
        meta: null,
        is404: true,
        isLoading: false
      })

      // return empty promise
      return Promise.all([])
    }
  },

  // fn: commit first dashboard to store
  commitFirstDashboard () {
    // get first dashboard
    let dashboard = store.getters.dashboards.byGroup[0]

    // if found -> set first dashboard as current
    if (dashboard) {
      return this.commitDashboard(dashboard)
    } else {
      // store: 404 store dashboard
      store.commit('dashboard', {
        meta: null,
        is404: true,
        isLoading: false
      })

      // return empty promise
      return Promise.all([])
    }
  },

  // fn: return true if user is below admin rights
  belowAdmin () {
    // get user object
    let user = store.getters.user

    // return true if no user or basic or manager
    return (!_.isObject(user) || user.role === 'basic' || user.role === 'manager')
  },

  // fn: return true if a user is an admin
  isAdmin () {
    // get user object
    let user = store.getters.user

    // return true if no user is an admin
    return (_.isObject(user) && user.role === 'admin')
  },

  // fn: returns true if user is superAdmin
  isSuperAdmin () {
    // get user object
    let user = store.getters.user

    // return true if user's role is superAdmin
    return (_.isObject(user) && user.role === 'superAdmin')
  }
}



// WEBPACK FOOTER //
// ./src/services/$glAuth.js